import React from 'react'

interface LoaderProps {
  type?: string
}

const Loader: React.FC<LoaderProps> = ({ type = 'page_loader' }) => {
  const style: any = {
    page_loader: 'after:border-neutral-8 after:border-t-primary-1',
    upload_loader:
      'after:border-neutral-9 after:border-t-neutral-1 bg-neutral-9 rounded-full',
  }
  return (
    <div
      className="absolute top-1/2 left-1/2 z-20 -translate-y-1/2  -translate-x-1/2"
      role="status"
      aria-label="Loading"
    >
      <div
        className={`after:contents-[''] flex h-full items-center justify-center after:h-[50px] after:w-[50px] after:animate-spin after:rounded-[50%] after:border-[7px] ${style[type]} `}
        aria-hidden="true"
      ></div>
    </div>
  )
}

export default Loader
